import React from "react";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';

const TableSkeleton = ({ count }) => {
    // Create an array of the specified count to map over
    const skeletons = Array.from({ length: count }, (_, i) => i);

    return (
        <React.Fragment>
            <tr>
                {skeletons.map(i => (
                    <td key={i}>
                        <Skeleton rect={true} count={1} width="100%" height={20} />
                    </td>
                ))}
            </tr>
            <tr>
                {skeletons.map(i => (
                    <td key={i}>
                        <Skeleton rect={true} count={1} width="100%" height={20} />
                    </td>
                ))}
            </tr>
            <tr>
                {skeletons.map(i => (
                    <td key={i}>
                        <Skeleton rect={true} count={1} width="100%" height={20} />
                    </td>
                ))}
            </tr>
            <tr>
                {skeletons.map(i => (
                    <td key={i}>
                        <Skeleton rect={true} count={1} width="100%" height={20} />
                    </td>
                ))}
            </tr>
        </React.Fragment>
    );
};

export default TableSkeleton;